var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "ui-input-field ui-field ui-outline-field" }, [
        _c("div", { staticClass: "ui-outline-field-wrapper" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputDate,
                expression: "inputDate",
              },
            ],
            attrs: { id: _vm._uid, pattern: _vm.pattern },
            domProps: { value: _vm.inputDate },
            on: {
              focus: _vm.onFocus,
              input: function ($event) {
                if ($event.target.composing) return
                _vm.inputDate = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "ui-outline" }, [
            _c("div", { staticClass: "ui-outline-left" }),
            _vm._v(" "),
            _c("div", { staticClass: "ui-outline-middle" }, [
              _c("label", { attrs: { for: _vm._uid } }, [
                _vm._v("\n            " + _vm._s(_vm.label) + "\n          "),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ui-outline-right" }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "keep-alive",
        [
          _vm.showDialog
            ? _c("md-datepicker-dialog", {
                attrs: {
                  "md-date": _vm.localDate,
                  "md-disabled-dates": _vm.mdDisabledDates,
                  mdImmediately: _vm.mdImmediately,
                },
                on: {
                  "update:mdDate": function ($event) {
                    _vm.localDate = $event
                  },
                  "update:md-date": function ($event) {
                    _vm.localDate = $event
                  },
                  "md-closed": _vm.toggleDialog,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("md-overlay", {
        staticClass: "md-datepicker-overlay",
        attrs: { "md-fixed": "", "md-active": _vm.showDialog },
        on: { click: _vm.toggleDialog },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }